import { useMemo } from 'react'

export interface AuthData {
  userId: string | null
  /**
   * The ecommerce add-on's `contact_uuid` for the current visitor.
   * Logged-in users: `context.current_user.external_id`.
   * Guests: a `guest-<uuid>` value persisted on the platformOS session by
   * the addon's `modules/ecommerce/user/get_user_uuid` partial-function.
   * Pass this as `contact_uuid` on every cart-mutating addon API call.
   */
  contactUuid: string | null
  isAuthenticated: boolean
  /** First name from `context.current_user.first_name`. */
  firstName: string | null
  /** Whatever `context.current_user.name` resolves to, falling back to email. */
  displayName: string | null
  email: string | null
}

export function useAuth(): AuthData {
  return useMemo(() => {
    const el = document.getElementById('auth-data')
    if (!el) {
      return {
        userId: null,
        contactUuid: null,
        isAuthenticated: false,
        firstName: null,
        displayName: null,
        email: null,
      }
    }
    return {
      userId: el.getAttribute('data-user-id') || null,
      contactUuid: el.getAttribute('data-contact-uuid') || null,
      isAuthenticated: el.getAttribute('data-is-authenticated') === 'true',
      firstName: el.getAttribute('data-first-name') || null,
      displayName: el.getAttribute('data-display-name') || null,
      email: el.getAttribute('data-email') || null,
    }
  }, [])
}
